// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BrandOfTheMonthModal-module__bom-form .Spinner-module__loading-spinner{margin:0 auto}", "",{"version":3,"sources":["webpack://src/components/newsletter/BrandOfTheMonthModalPortal/BrandOfTheMonthModal/BrandOfTheMonthModal_generalClasses.scss"],"names":[],"mappings":"AACE,wEACE,aAAA","sourcesContent":[".BrandOfTheMonthModal-module__bom-form {\n  .Spinner-module__loading-spinner {\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
